import { resolveBrowserOneTrustCookieStatus } from "./OneTrustCookieStatus";
import { usePerformanceConsent } from "./usePerformanceConsent";

type UseOneTrustPerformanceGateOptions = {
  domainScript?: string;
};

export function useOneTrustPerformanceGate({
  domainScript,
}: UseOneTrustPerformanceGateOptions = {}) {
  const oneTrustStatus = resolveBrowserOneTrustCookieStatus(domainScript);
  const performanceAllowed = usePerformanceConsent({
    oneTrustEnabled: oneTrustStatus.shouldUseConsentGating,
  });

  return { oneTrustStatus, performanceAllowed };
}
